// extracted by mini-css-extract-plugin
export default {"accountPopover":"AccountPopoverContent_accountPopover__-5sl3"};